var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7974 6.87207H7.20047C3.7966 6.87207 0.779297 9.76664 0.779297 13.3486V25.2499C0.779297 28.8345 3.79679 31.6122 7.20047 31.6122H16.9921L15.5087 36.5865C15.3796 37.4373 16.1962 37.8564 16.9086 37.5363L28.9661 31.6122H29.7971C33.1984 31.6122 36.0045 28.8346 36.0045 25.2499V13.3486C36.0045 9.76664 33.1984 6.87207 29.7971 6.87207H29.7974Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3201 -0.000286611H13.7232C11.1115 -0.000286611 8.74082 1.71102 7.77148 4.1232H29.7967C34.6592 4.1232 38.6139 8.2616 38.6139 13.3483V24.2848C40.8943 23.3613 42.528 21.107 42.528 18.3773L42.5277 6.47608C42.5277 2.89408 39.7216 -0.000488281 36.3203 -0.000488281L36.3201 -0.000286611Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.23b7acd4f5d17cb8f50b689e35ce263f.svg";
export { ForwardRef as ReactComponent };